import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export default class BlacklistActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({type: this.type = BlacklistActionModel.Types.fingerprint, ttl: this.ttl = 30} = fields);
    }

    static Types = {
        customerId: 'customer-id',
        email: 'email',
        fingerprint: 'fingerprint',
        ipAddress: 'ip-address',
        paymentCard: 'payment-card',
    };

    getPayload() {
        return {
            ...super.getPayload(),
            type: this.type,
            ttl: Number(this.ttl),
        };
    }
}
